require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./separator"), require("./svgicon"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./separator", "./svgicon", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./separator"), require("./svgicon"), require("./utils")) : factory(root["./separator"], root["./svgicon"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__16717__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[2882],{

/***/ 14949:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _separator = _interopRequireDefault(__webpack_require__(16717));
var _svgicon = __webpack_require__(56685);
var _baUiCarbon = __webpack_require__(6536);
var _crop_ = _interopRequireDefault(__webpack_require__(71787));
var _edit_ = _interopRequireDefault(__webpack_require__(1046));
var _image_ = _interopRequireDefault(__webpack_require__(43669));
var _refined_ = _interopRequireDefault(__webpack_require__(45083));
var _filter_ = _interopRequireDefault(__webpack_require__(94798));
var _videoFile_ = _interopRequireDefault(__webpack_require__(39717));
var _settingsAdjust_ = _interopRequireDefault(__webpack_require__(5158));
var _redo_ = _interopRequireDefault(__webpack_require__(5506));
var _textCreation_ = _interopRequireDefault(__webpack_require__(94617));
var _undo_ = _interopRequireDefault(__webpack_require__(45230));
var _webpage_ = _interopRequireDefault(__webpack_require__(21089));
__webpack_require__(29201);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const cogButtons = {
  crop: {
    icon: _crop_.default,
    desc: 'Crop'
  },
  editPreview: {
    icon: _edit_.default,
    desc: 'Edit or preview'
  },
  fields: {
    icon: _refined_.default,
    desc: 'Fields'
  },
  filters: {
    icon: _filter_.default,
    desc: 'Filters'
  },
  image: {
    icon: _image_.default,
    desc: 'Image'
  },
  media: {
    icon: _videoFile_.default,
    desc: 'Media'
  },
  properties: {
    icon: _settingsAdjust_.default,
    desc: 'Properties'
  },
  redo: {
    icon: _redo_.default,
    desc: 'Redo'
  },
  text: {
    icon: _textCreation_.default,
    desc: 'Text'
  },
  undo: {
    icon: _undo_.default,
    desc: 'Undo'
  },
  webPage: {
    icon: _webpage_.default,
    desc: 'WebPage'
  }
};
const {
  BaPropTypes
} = _utils.propsUtils;

// Toolbar.Spacer layout helper: deprecated Carbon pattern does not include spacers in toolbars
const Spacer = () => null;
Spacer.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  size: BaPropTypes.deprecated('deprecated - Carbon pattern does not include spacers (If you really want a spacer you can add it as a toolbar item).')
};

// Toolbar.Separator layout helper: render a vertical separator bar (size prop is no longer supported)
// extract 'size' before making use of 'passThrough'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const VSeparator = _ref => {
  let {
    size,
    ...passThrough
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_separator.default, (0, _extends2.default)({
    "data-tid": "ba-common-toolbar__v-separator",
    orientation: "vertical",
    hMargin: 0
  }, passThrough));
};
VSeparator.propTypes = {
  /**  BaPropTypes.deprecated('deprecated - Carbon only supports a thin line. All separtors will be mapped to a thin line.'), */
  size: BaPropTypes.deprecated('deprecated - Carbon only supports a thin line. All separtors will be mapped to a thin line.')
};

// Toolbar.Button item helper: renders a button
const Button = props => {
  const {
    cogType,
    kind: _kind = 'ghost',
    // eslint-disable-line react/prop-types
    ...buttonProps
  } = props;
  let {
    children: _children,
    hasIconOnly: _hasIconOnly,
    iconDescription: _iconDescription,
    renderIcon: _renderIcon,
    title: _title // eslint-disable-line react/prop-types
  } = props;
  if (cogType) {
    var _children2, _iconDescription2, _renderIcon2, _title2;
    _children = (_children2 = _children) != null ? _children2 : cogButtons[cogType].desc;
    _iconDescription = (_iconDescription2 = _iconDescription) != null ? _iconDescription2 : cogButtons[cogType].desc;
    _renderIcon = (_renderIcon2 = _renderIcon) != null ? _renderIcon2 : props => (0, _svgicon.createIcon)(cogButtons[cogType].icon.id, 'small', null, null, props);
    _title = (_title2 = _title) != null ? _title2 : cogButtons[cogType].desc;
  }
  if (!_renderIcon) {
    var _title3;
    _iconDescription = undefined;
    _hasIconOnly = undefined;
    _title = (_title3 = _title) != null ? _title3 : _children;
  } else if (_hasIconOnly) {
    var _iconDescription3;
    _iconDescription = (_iconDescription3 = _iconDescription) != null ? _iconDescription3 : _children;
    _title = undefined;
    _children = undefined;
  } else {
    var _title4;
    _iconDescription = undefined;
    _title = (_title4 = _title) != null ? _title4 : _children;
  }
  return /*#__PURE__*/_react.default.createElement(_baUiCarbon.Button, (0, _extends2.default)({}, buttonProps, {
    hasIconOnly: _hasIconOnly,
    iconDescription: _iconDescription,
    kind: _kind,
    renderIcon: _renderIcon,
    title: _title
  }), _children);
};
Button.propTypes = {
  /** The label for the button */
  children: _propTypes.default.node,
  /** A cognos predefined button type */
  cogType: _propTypes.default.oneOf(Object.keys(cogButtons)),
  /** Indictates it is an icon only button */
  hasIconOnly: _propTypes.default.bool,
  /** icon tooltip */
  iconDescription: _propTypes.default.string,
  /** onClick callback function */
  onClick: _propTypes.default.func.isRequired,
  /** icon to render */
  renderIcon: _propTypes.default.node
};
VSeparator.isSeparator = true;
class Toolbar extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "_flexWrap", () => {
      const {
        flexWrap = 'wrap'
      } = this.props;
      const {
        breakpoint = flexWrap === 'wrap' ? 'md' : 'max'
      } = this.props;

      // TODO: the Toolbar responsiveness defined in the Carbon toolbar is complicated
      // and doesn't map to the standard html wrappings ('wrap', 'nowrap', 'wrap-reverse')
      if (breakpoint === 'max' || breakpoint === 'xlg') {
        // Displays all controls and functionality in one row
        // with the option to make the search field longer or shorter
        return 'nowrap';
      } else if (breakpoint === 'lg') {
        // The search field is truncated into a button
        // or use an overflow menu to display collapsed controls
        return 'nowrap';
      } else if (breakpoint === 'md') {
        // Compresses the full text toolbar into two rows
        return 'wrap';
      } else if (breakpoint === 'sm') {
        // A more compact version of “md” with collapsed controls in an overflow menu
        return 'wrap';
      }
    });
  } // define Toolbar.xxxx layout helpers
  // define Toolbar.xxxx item helpers
  _isSeparator(component) {
    if (component && component.type && component.type.isSeparator) return true;
    return false;
  }
  render() {
    const {
      align,
      border,
      breakpoint,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      children,
      className,
      orientation,
      style,
      variant,
      // remove - props deprecated
      flexWrap,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      gap,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      // other props to apply to the toolbar wrapper
      ...toolbarProps
    } = this.props;
    const classNames = (0, _utils.classnames)('ba-common-toolbar', align, variant, orientation, {
      border
    });
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, toolbarProps, {
      className: `${classNames} ${className}`,
      style: {
        flexWrap: this._flexWrap(),
        ...style
      }
    }), _react.default.Children.map(children, (child, i) => /*#__PURE__*/_react.default.createElement("div", {
      className: `ba-common-toolbar__item ${this._isSeparator(child) ? (0, _utils.classnames)('separator') : ''}`,
      key: i,
      onKeyDown: e => {
        if (e.keyCode === 13) {
          e.preventDefault();
          e.stopPropagation();
          if (child.props.onClick) child.props.onClick();
        }
      }
    }, child)));
  }
}
exports["default"] = Toolbar;
(0, _defineProperty2.default)(Toolbar, "LeftItems", _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _utils.classnames)('itemLeft')
  }, children);
});
(0, _defineProperty2.default)(Toolbar, "RightItems", _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _utils.classnames)('itemRight')
  }, children);
});
(0, _defineProperty2.default)(Toolbar, "propTypes", {
  /** Align the toolbar */
  align: _propTypes.default.oneOf(['right', 'left', 'center']),
  /** Put a 1px solid boarder around the Toolbar */
  border: _propTypes.default.bool,
  /** Define the breakpoints for the responsiveness of the Toolbar */
  breakpoint: _propTypes.default.oneOf(['max', 'xlg', 'lg', 'md', 'sm']),
  /** Toolbar items */
  children: _propTypes.default.node.isRequired,
  /** Custom class name(s) */
  className: _propTypes.default.string,
  /** ?deprecated? - Specifies whether the toolbar will be drawn horizontally or vertically (Carbon does not have a vertical pattern) */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
  /** Custom css styles applied to the toolbar wrapper */
  style: _propTypes.default.object,
  /** Align options are disabled under inline mode. Only select align options when variant is frame */
  variant: _propTypes.default.oneOf(['frame', 'inline']),
  /** deprecated - use Carbon prop breakpoint */
  flexWrap: BaPropTypes.deprecated('deprecated - use Carbon prop breakpoint'),
  /** deprecated - Carbon pattern does not support gap */
  gap: BaPropTypes.deprecated('deprecated - Carbon pattern does not support gap/spacer')
});
(0, _defineProperty2.default)(Toolbar, "defaultProps", {
  align: 'left',
  border: false,
  breakpoint: undefined,
  children: undefined,
  className: '',
  orientation: 'horizontal',
  style: {},
  variant: 'inline',
  // deprecated
  flexWrap: undefined,
  gap: undefined
});
(0, _defineProperty2.default)(Toolbar, "Spacer", Spacer);
(0, _defineProperty2.default)(Toolbar, "Separator", VSeparator);
(0, _defineProperty2.default)(Toolbar, "Button", Button);

/***/ }),

/***/ 50929:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Toolbar = _interopRequireDefault(__webpack_require__(14949));
exports["default"] = _Toolbar.default;
exports.Toolbar = _Toolbar.default;

/***/ }),

/***/ 6700:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-toolbar{position:relative;margin:0px;align-items:center}.ba-common-toolbar:focus{outline:2px solid #a8c0f3}.ba-common-toolbar.is-inline{display:inline-flex}.ba-common-toolbar.is-frame{display:flex}.ba-common-toolbar.is-vertical{display:inline-block}.ba-common-toolbar.is-border{border-width:1px;border-style:solid}.ba-common-toolbar.is-left{justify-content:flex-start}.ba-common-toolbar.is-right{justify-content:flex-end}.ba-common-toolbar .is-itemLeft{position:absolute;left:0;top:0}.ba-common-toolbar .is-itemRight{position:absolute;right:0;top:0}.ba-common-toolbar.is-center{justify-content:center}.ba-common-toolbar.is-center .ba-common-toolbar__item{margin-right:8px;margin-left:8px}.ba-common-toolbar__item{min-width:0}.ba-common-toolbar__item.is-separator{align-self:stretch}.ba-common-toolbar.is-border{border-color:#949394}", ""]);

// exports
exports.locals = {
	"toolbarClassName": "\"ba-common-toolbar\""
};

/***/ }),

/***/ 29201:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6700);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Toolbar_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 71787:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/crop_32");

/***/ }),

/***/ 1046:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/edit_32");

/***/ }),

/***/ 94798:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/filter_32");

/***/ }),

/***/ 43669:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/image_32");

/***/ }),

/***/ 5506:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/redo_32");

/***/ }),

/***/ 45083:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/refined_16");

/***/ }),

/***/ 5158:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/settings--adjust_32");

/***/ }),

/***/ 94617:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/text--creation_32");

/***/ }),

/***/ 45230:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/undo_32");

/***/ }),

/***/ 39717:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/video-file_32");

/***/ }),

/***/ 21089:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/webpage_32");

/***/ }),

/***/ 6536:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 16717:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__16717__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(50929));
/******/ return __webpack_exports__;
/******/ }
]);
});